import {bookingApi} from "../../API/API";
import {SET_BOOKING} from "./constans";





export const setBooking = (payload) => {
    return {
        type: SET_BOOKING,
        payload: payload
    }
}


export const getBooking = (bookingId) => async (dispatch) => {
    let response = await bookingApi.getBooking(bookingId);
    if (response.status) {
        dispatch(setBooking(response.data))
    }
}


export const setBookingStatus = (data) => async (dispatch) => {
    let response = await bookingApi.setStatus(data);

    if (response.status) {
        dispatch(setBooking(response.data))
    }
}